import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de3bd17dbe0d82/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de3bd17dbe0d82/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de3bd17dbe0d82/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFAQ"] */ "/tmp/8de3bd17dbe0d82/components/sections/KioskFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFeatures"] */ "/tmp/8de3bd17dbe0d82/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRCaseStudy"] */ "/tmp/8de3bd17dbe0d82/components/sections/QRCaseStudy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRLocations"] */ "/tmp/8de3bd17dbe0d82/components/sections/QRLocations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRShowcase"] */ "/tmp/8de3bd17dbe0d82/components/sections/QRShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de3bd17dbe0d82/components/ui/Section.module.css");
